import React from "react";
import PropTypes from "prop-types";
import { Tabs as AntTabs } from "antd";
import "./style.css";

// Define your components for the tab contents
const SingleProductUpload = () => <div>Single Product Upload Content</div>;
const BulkProductUpload = () => <div>Bulk Product Upload Content</div>;

const Tabs = ({ items, onChange, className, size, activeKey }) => {
  console.log("activeKey : ", activeKey);
  return (
    <div className="tabs-container">
      <AntTabs
        className={className}
        size={size}
        onChange={onChange}
        items={items}
        activeKey={activeKey}
      />
    </div>
  );
};

Tabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      children: PropTypes.node.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func,
  size: PropTypes.string,
  activeKey: PropTypes.string,
};

Tabs.defaultProps = {
  className: "",
  size: "small",
  onChange: (key) => {
    console.log(key);
  },
  activeKey: "1",
};

export default Tabs;
